import { useEffect, useState } from "react";
import { toast } from "sonner";
import { AdminGuard } from "@/components/admin/AdminGuard";
import { errText } from "@/lib/api";
import { adminGiftAction, adminGiftCards } from "@/lib/admin";
import { cad } from "@/lib/site";

const Panel = () => {
  const [rows, setRows] = useState(null);
  const load = () => adminGiftCards().then(setRows);
  useEffect(() => { load(); }, []);
  const act = async (code, action) => { try { await adminGiftAction(code, action); toast.success(action === "resend" ? "Gift card email sent" : "Gift card disabled"); load(); } catch (e) { toast.error(errText(e)); } };
  return (
    <div data-testid="admin-gift-cards">
      <h1 className="display text-6xl">Gift cards</h1>
      <div className="mt-8 overflow-x-auto"><table className="w-full text-left text-sm">
        <thead><tr className="label border-b border-ink/15 text-ink/60"><th className="py-3">Code</th><th>Balance</th><th>Status</th><th>To</th><th>From</th><th>Send date</th><th>Email</th><th /></tr></thead>
        <tbody>{rows?.map((g) => (
          <tr key={g.code} className="border-b border-ink/10" data-testid={`admin-gift-${g.code}`}>
            <td className="py-3 font-mono">{g.code}</td><td>{cad(g.balance)} / {cad(g.initial)}</td><td><span className="label rounded-full bg-ink/5 px-2 py-0.5">{g.status}</span></td>
            <td>{g.recipient_name}<br /><span className="text-ink/60">{g.recipient_email}</span></td><td>{g.sender_name}<br /><span className="text-ink/60">{g.order_number}</span></td>
            <td>{g.send_at?.slice(0, 10)}</td><td>{g.sent_at && g.sent_at !== "sending" ? g.email_status : "scheduled"}</td>
            <td className="space-x-3 whitespace-nowrap">{g.status !== "disabled" && <><button onClick={() => act(g.code, "resend")} className="link-u" data-testid={`admin-gift-resend-${g.code}`}>Resend</button><button onClick={() => act(g.code, "disable")} className="link-u text-alert" data-testid={`admin-gift-disable-${g.code}`}>Disable</button></>}</td>
          </tr>))}</tbody></table>
        {rows && !rows.length && <p className="mt-6 text-ink/60">No gift cards sold yet.</p>}</div>
    </div>
  );
};

export default function AdminGiftCards() {
  return <AdminGuard><Panel /></AdminGuard>;
}
